import { Fragment } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  useTableRowModClassName,
} from '../../../../Table'

import { renderViewingProfileDocumentsCell } from './ViewingProfileDocumentsRow.utils'

import * as styles from './ViewingProfileDocumentsRow.module.css'

function ViewingProfileDocumentsRow({
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
}) {
  const className = useTableRowModClassName({
    className: styles.ViewingProfileDocumentsRow,
    isActive: focusedRow === item.id,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderViewingProfileDocumentsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            nameCellClassName: styles.nameCell,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default ViewingProfileDocumentsRow
